// extracted by mini-css-extract-plugin
export default {"holder":"styles_holder__3zUPU","calendar":"styles_calendar__a80-G"};